import { observable, action, computed, makeObservable } from "mobx";
import { DataCondition } from "../../../contracts";
export class Condition {
    constructor(...keys) {
        this.units = new Map(keys.map(k => [k, DataCondition.LOADING]));
        makeObservable(this, {
            units: observable,
            set: action,
            setEach: action,
            value: computed,
        });
    }
    reset() {
        this.setEach(DataCondition.LOADING);
    }
    set(key, condition) {
        this.units.set(key, condition);
    }
    get value() {
        return this.resolveCondition();
    }
    setEach(condition) {
        [...this.units.keys()].forEach(k => this.set(k, condition));
    }
    /*
    * The order of the condition is important from requirements perspective
    */
    resolveCondition() {
        const dataConditions = [...this.units.values()];
        if (dataConditions.includes(DataCondition.ERROR)) {
            return DataCondition.ERROR;
        }
        if (dataConditions.includes(DataCondition.EMPTY)) {
            return DataCondition.EMPTY;
        }
        if (dataConditions.every(x => x === DataCondition.LOADED)) {
            return DataCondition.LOADED;
        }
        return DataCondition.LOADING;
    }
}
//# sourceMappingURL=Condition.js.map